import { render, staticRenderFns } from "./IconBookmarkFull.vue?vue&type=template&id=1ab860dc&"
import script from "./IconBookmarkFull.vue?vue&type=script&lang=js&"
export * from "./IconBookmarkFull.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports